import { render, staticRenderFns } from "./UpdateRecipe.vue?vue&type=template&id=1469b27e&"
import script from "./UpdateRecipe.vue?vue&type=script&lang=js&"
export * from "./UpdateRecipe.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRecipe.vue?vue&type=style&index=0&id=1469b27e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports